import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { AbbIconComponent } from '@components/abb-icon/abb-icon.component';
import { OutcomeIndicator } from 'gql/graphql';

@Component({
  selector: 'abb-outcome-indicator',
  standalone: true,
  imports: [AbbIconComponent, CommonModule],
  template: `
    @switch (indicator()) { @case (OutcomeIndicator.Ok) {
    <abb-icon [size]="size()" [name]="okIcon()" class="text-abb-success" />
    } @case (OutcomeIndicator.Ko) {
    <abb-icon [size]="size()" [name]="koIcon()" class="text-abb-error" />
    }}
  `,
  styles: ``,
})
export class AbbOutcomeIndicatorComponent {
  indicator = input.required<OutcomeIndicator>();
  size = input<'small' | 'medium' | 'large'>('medium');
  variant = input<'filled' | 'outlined'>('filled');
  readonly OutcomeIndicator = OutcomeIndicator;
  okIcon = computed(() =>
    this.variant() === 'filled'
      ? 'abb/check-mark-circle-1'
      : 'mat-outlined/check_circle'
  );
  koIcon = computed(() =>
    this.variant() === 'filled'
      ? 'abb/warning-circle-1'
      : 'mat-outlined/error_outline'
  );
}
